import { createContext, useContext } from "react";

export const ProductOverlayContext = createContext(null);

export const useProductOverlay = () => useContext(ProductOverlayContext);

export const isPlainLeftClick = (event) =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
